import React, { useContext, useState } from "react"
import { useNavigate } from "react-router-dom";
import axios from "axios"
import { Navigate } from "react-router-dom";
import styles from "../styles/Login.module.css"
import { Button,InputRightAddon,Input,InputGroup ,InputLeftAddon,Stack} from '@chakra-ui/react'
import { useToast ,Box} from '@chakra-ui/react'
function Register(){
    const navigate = useNavigate()
    let [name,setName] = useState("")
    let [email,setEmail] = useState("")
    let [password,setPassword] = useState("")
    const toast = useToast()

    function addLogin(){
        
        axios.post(`${process.env.REACT_APP_API}/users`,{id: Math.random() ,email: email, password: password, username: name})
        .then((res)=> { 
            
            toast({

            render: () => (
              <Box color='white' p={3} bg='blue.500'>
                Sign UP Successfully
              </Box>
            )
          })
        navigate("/login")
        } ).catch((err)=>console.log(err))
    }
    console.log(`${process.env.REACT_APP_API}/users`);
    return (

<div className={styles.mainLogin}>
                <div className={styles.loginForm}>
                    <img src="https://assets.myntassets.com/f_webp,dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/2023/1/25/f5e9a029-33c3-4a92-811b-ef7917fe6d441674670210687-offer-banner-300-600x240-code-_-MYNTRA300.jpg" alt="" />
                    <div className={styles.lform}>
                    <h1 className={styles.heading}>Sign up</h1>
                    <form>
                    <Stack spacing={4}>
      
      <Input className={styles.input}  onChange={(e)=> {setName(e.target.value)}} value={name} placeholder="Enter Name"  />
      <Input className={styles.input} onChange={(e)=> {setEmail(e.target.value)}}  placeholder="Enter Email" />
    <Input className={styles.input} onChange={(e)=> {setPassword(e.target.value)}}  type='password'  placeholder='Enter Password' />
      <Button  fontSize='13px' size={"sm"} onClick={addLogin}> Sign Up </Button>
    </Stack>
    
                    </form>
                    <p style={{cursor:"pointer"}} onClick={()=> navigate("/login")}>click here login</p>
    
                    </div>
                   
                </div>
            </div>

    )
}
export default Register;